import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';
import { useUser } from 'state/auth';
import { useInviteCodeQuery } from 'state/queryParams';
import { APP_ROUTES } from 'utils/navigation';

const SignupRoute = () => {
  const { user, isUserEmailVerified } = useUser();
  const inviteCodeQuery = useInviteCodeQuery();
  const { logout } = useAuth();
  const [isFinishedMounting, setIsFinishedMounting] = useState(false);

  useEffect(() => {
    if (inviteCodeQuery && user) {
      logout();
    }
    setIsFinishedMounting(true);
  }, []);

  if (!isFinishedMounting) {
    return null;
  }

  if (!isUserEmailVerified && user) {
    return <Navigate to="/email-verification" />;
  }

  if (user) {
    return <Navigate to={APP_ROUTES.DASHBOARD_PROJECT_GROUPS} />;
  }

  return <Outlet />;
};

export default SignupRoute;
